import React, { FC } from 'react';
import Routes from './routes'
import './App.css';

const App: FC = () => (
  <Routes />
)

export default App;
